import React, { useCallback, useState } from 'react';
import { Button, Card, Typography } from '@sravni/react-design-system';
import { ESIA_TYPE, getLoginUrl, LOGIN_TYPE } from '@sravni/utils/lib/auth';
import { EventType, useAnalytics } from '../../hooks/analytics';
import { useFormFields } from '../../../store/selectors/formStore';
import { FORM_FIELDS, QUERY_PARAMS } from '../../../constants';
import { sourceNameByValue } from '../../../helpers';
import { PERIOD_SOURCE, PURPOSE_SOURCE } from '../../../constants/sources';
import styles from './styles.module.scss';

const { Heading, Text } = Typography;

/** Компонент авторизации через Госуслуги для формы */
export const GosuslugiAuth: React.FC = () => {
    const { pushEvent } = useAnalytics();
    const [inProcess, setInProcess] = useState(false);
    const [amount, period, purpose, region] = useFormFields([
        FORM_FIELDS.AMOUNT,
        FORM_FIELDS.PERIOD,
        FORM_FIELDS.PURPOSE,
        FORM_FIELDS.REGION,
    ]);

    const onClickLogin = useCallback(() => {
        const periodMapped = sourceNameByValue(period, PERIOD_SOURCE);
        const purposeMapped = sourceNameByValue(purpose, PURPOSE_SOURCE);

        pushEvent({
            event: EventType.mainEvent,
            eventAction: 'Шаг 1|Параметры',
            eventLabel: [
                `Ручное|Сумма кредита - ${amount}`,
                `На какой срок - ${periodMapped} `,
                `Город получения - ${region}`,
                `Цель кредита - ${purposeMapped}`,
                'Авторизация - ESIA',
            ].join('|'),
        });

        const returnUrl = new URL(location.href);
        returnUrl.searchParams.set(QUERY_PARAMS.ESIA, '1');

        const loginUrl = getLoginUrl({
            loginType: LOGIN_TYPE.ESIA,
            esiaType: ESIA_TYPE.STRICT,
            returnUrl: returnUrl.toString(),
        });

        if (loginUrl) {
            setInProcess(true);
            location.href = loginUrl;
        }
    }, [pushEvent, amount, period, purpose, region]);

    return (
        <Card className={styles.root} variant="secondary" color="blue" size={16}>
            <div className={styles.logo} />
            <div>
                <Heading level={4} className={styles.heading}>
                    Заполнить через Госуслуги
                </Heading>
                <Text size={12}>Чтобы узнать максимальную сумму, которую вам могут одобрить банки</Text>
            </div>
            <Button variant="primary" color="gray" type="button" onClick={onClickLogin} size={52} loading={inProcess}>
                Заполнить
            </Button>
        </Card>
    );
};
